import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import HeaderComp from '../CommanCom/HeaderComp'
import FooterComp from '../CommanCom/FooterComp'
import LeftComp from '../AppCom/HR/LeftComp'
import PermissionDeniedCom from "../ErrorPage/PermissionDeniedCom"

function HrRoutes({ redirectpath = 'login', children, header_title, menu_id }) {
    const menu_permission = useSelector(state => state.login_Permission.permissions)


    const hr_permission_arr = Array()
    if (menu_permission) {
      const hr_permission_arr1 = JSON.parse(menu_permission).split(",")
      hr_permission_arr1.map((item, ind) => {
        hr_permission_arr.push(item);
      })
    }

    return (
        <div className="user_main_container">

            <HeaderComp />
            <main id="dash_content_area">
                <LeftComp />
                <div id="content_area">
                    {hr_permission_arr.includes(menu_id?.toString()) ? children ? children : <PermissionDeniedCom /> : <PermissionDeniedCom />}
                    <FooterComp />
                </div>
            </main>
        </div>
    )
}

export default HrRoutes
